import { render, staticRenderFns } from "./DestinationCard.vue?vue&type=template&id=6d6ff634&"
import script from "./DestinationCard.vue?vue&type=script&lang=ts&"
export * from "./DestinationCard.vue?vue&type=script&lang=ts&"
import style0 from "./DestinationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports